import { Sorts } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ESortOrder } from "@domains/utils/sort";
export var EOrderBookTabs;
(function (EOrderBookTabs) {
    EOrderBookTabs["OPENORDER"] = "openorders";
    EOrderBookTabs["CLOSEORDER"] = "closedorders";
    // GTT = "gtt",
    EOrderBookTabs["ESIP"] = "esip";
})(EOrderBookTabs || (EOrderBookTabs = {}));
export var MFOrderBookTabs;
(function (MFOrderBookTabs) {
    MFOrderBookTabs["OPENORDER"] = "openorders";
    MFOrderBookTabs["CLOSEORDER"] = "closedorders";
    MFOrderBookTabs["ESIP"] = "esip";
})(MFOrderBookTabs || (MFOrderBookTabs = {}));
export var CommodityOrderBookTabs;
(function (CommodityOrderBookTabs) {
    CommodityOrderBookTabs["OPENORDER"] = "openorders";
    CommodityOrderBookTabs["CLOSEORDER"] = "closedorders";
})(CommodityOrderBookTabs || (CommodityOrderBookTabs = {}));
export var OrderbookTocStateEnum;
(function (OrderbookTocStateEnum) {
    OrderbookTocStateEnum["MODIFY"] = "MODIFY";
    OrderbookTocStateEnum["REORDER"] = "REORDER";
    OrderbookTocStateEnum["DEFAULT"] = "DEFAULT";
})(OrderbookTocStateEnum || (OrderbookTocStateEnum = {}));
export const orderBookStatus = {
    [EOrderBookTabs.OPENORDER]: [
        "open",
        // "In progress",
        "AMO req received",
        // "modify AMO req received",
        // "validation pending",
        "trigger pending",
    ],
    [EOrderBookTabs.CLOSEORDER]: [
        "complete",
        "rejected",
        "cancelled",
        "completed",
        "cancelled AMO",
    ],
    [EOrderBookTabs.ESIP]: ["expired"],
};
export const mfOrderBookStatus = {
    [EOrderBookTabs.OPENORDER]: ["open", "In progress"],
    [EOrderBookTabs.CLOSEORDER]: ["complete", "REJECTED", "cancelled"],
};
export const nfoOrderBookStatus = {
    [EOrderBookTabs.OPENORDER]: ["open", "In progress"],
    [EOrderBookTabs.CLOSEORDER]: ["complete", "REJECTED", "cancelled"],
};
export const orderBookFilterSort = [
    { title: "Sort", eventKey: "Sort" },
    { title: "Filters", eventKey: "Filters" },
];
export const orderBookRows = {
    quantity: "0 / 10",
    limitprice: "423.05",
    triggerprice: "NA",
};
export const orderbookFilters = [
    {
        filterName: "Action",
        eventKey: "trsTyp",
        list: [
            { title: "BUY", key: "BUY", selected: false },
            { title: "SELL", key: "SELL", selected: false },
        ],
        selectType: "radio",
    },
    {
        filterName: "Product Type",
        list: [
            { title: "CNC", key: "CNC", selected: false },
            { title: "NRML", key: "NRML", selected: false },
            { title: "MTF", key: "MTF", selected: false },
            { title: "MIS", key: "MIS", selected: false },
            { title: "BO", key: "BO", selected: false },
        ],
        selectType: "checkbox",
        eventKey: "prdCode",
    },
    // {
    //   filterName: "Order Status",
    //   list: [
    //     { title: "Open", key: "Open", selected: false },
    //     { title: "Completed", key: "Completed", selected: false },
    //     { title: "Cancelled", key: "Cancelled", selected: false },
    //     { title: "Rejected", key: "Rejected", selected: false },
    //   ],
    //   selectType: "checkbox",
    //   eventKey: "t3",
    // },
    // {
    //   filterName: "Order Last modified",
    //   list: [
    //     { title: "3 Months", key: "three", selected: false },
    //     { title: "6 Months", key: "six", selected: false },
    //     { title: "9 Months", key: "nine", selected: false },
    //     { title: "Select Date Range", key: "date", selected: false },
    //   ],
    //   selectType: "checkbox",
    //   eventKey: "t4",
    // },
];
export const sipOrderbookFilters = [
    {
        filterName: "Order Status",
        list: [
            { title: "Open", key: "Open", selected: false },
            { title: "Completed", key: "Completed", selected: false },
            { title: "Cancelled", key: "Cancelled", selected: false },
            { title: "Rejected", key: "Rejected", selected: false },
        ],
        selectType: "checkbox",
        eventKey: "sts",
    },
    {
        filterName: "Product Type",
        list: [
            { title: "CNC", key: "CNC", selected: false },
            { title: "NRML", key: "NRML", selected: false },
        ],
        selectType: "checkbox",
        eventKey: "prCd",
    },
];
export const sortlistorderbook = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "dpName",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
            type: "string",
        },
        {
            title: "Action",
            key: "trsTyp",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Sell First", desc: "Buy First" },
            type: "string",
        },
    ]),
];
export const sortlistesiporderbook = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "tsym",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
            type: "string",
        },
        {
            title: "Amount",
            key: "amt",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Low to High", desc: "High to Low" },
            type: "number",
        },
        {
            title: "Order Date",
            key: "stDt",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Older to Newer", desc: "Newer to Older" },
            type: "string",
        },
    ]),
];
export const fundFiltersorderbookfilter = [
    {
        title: "Action",
        eventKey: "Action",
        tabContent: "Action",
        backToTop: true,
    },
    { title: "Product Type", eventKey: "ProductType", tabContent: "ProductType" },
    { title: "Order Status", eventKey: "OrderStatus", tabContent: "OrderStatus" },
    {
        title: "Order Last modified",
        eventKey: "OrderLastmodified",
        tabContent: "Order Last modified",
    },
];
export const orderData = [
    {
        stock: "TATA MOTORS",
        streamValue: "423.05",
        streamprice: "+2.00 (+0.47%)",
        status: "open",
        actionQty: "0/10",
        stopLossLimitPrice: "423.05",
        stopLossTriPrice: "425.05",
    },
    {
        stock: "TATA MOTORS",
        streamValue: "423.05",
        streamprice: "+2.00 (+0.47%)",
        status: "open",
        actionQty: "0/10",
        stopLossLimitPrice: "423.05",
        stopLossTriPrice: "425.05",
    },
    {
        stock: "TATA MOTORS",
        streamValue: "423.05",
        streamprice: "+2.00 (+0.47%)",
        status: "open",
        actionQty: "0/10",
        stopLossLimitPrice: "423.05",
        stopLossTriPrice: "425.05",
    },
];
export var MFOrderBookType;
(function (MFOrderBookType) {
    MFOrderBookType["Regular"] = "Regular";
    MFOrderBookType["Hold"] = "Hold";
})(MFOrderBookType || (MFOrderBookType = {}));
export const mfOrderbook = [
    { title: "Regular", value: MFOrderBookType.Regular },
    { title: "Hold", value: MFOrderBookType.Hold },
];
export var EorderBookButtonsList;
(function (EorderBookButtonsList) {
    EorderBookButtonsList["ALL"] = "ALL";
    EorderBookButtonsList["EQ"] = "OrderEquity";
    // FUT = "fu",
    // OPT = "op",
    EorderBookButtonsList["MF"] = "mf";
    EorderBookButtonsList["NFO"] = "nfo";
    EorderBookButtonsList["COMOD"] = "commodity";
    // ETF = "ETF",
    EorderBookButtonsList["NCD"] = "NCD";
    EorderBookButtonsList["IPO"] = "ipo";
    EorderBookButtonsList["SGB"] = "sgb";
    EorderBookButtonsList["CORPFD"] = "corpdfd";
    EorderBookButtonsList["OFS"] = "ofs";
})(EorderBookButtonsList || (EorderBookButtonsList = {}));
